import { render, staticRenderFns } from "./newloan.vue?vue&type=template&id=49547fca&scoped=true&"
import script from "./newloan.vue?vue&type=script&lang=js&"
export * from "./newloan.vue?vue&type=script&lang=js&"
import style0 from "./newloan.vue?vue&type=style&index=0&id=49547fca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49547fca",
  null
  
)

export default component.exports